// extracted by mini-css-extract-plugin
export default {"title":"mIhH4","smallViewport":"xpeLp","message":"TuLPz","header":"CLA2B","image":"cWbhx"};